import { render, staticRenderFns } from "./ShippingLabelForm.vue?vue&type=template&id=41a2af6e&scoped=true&"
import script from "./ShippingLabelForm.vue?vue&type=script&lang=js&"
export * from "./ShippingLabelForm.vue?vue&type=script&lang=js&"
import style0 from "./ShippingLabelForm.vue?vue&type=style&index=0&id=41a2af6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a2af6e",
  null
  
)

export default component.exports